import { render } from "./MessageEditor.vue?vue&type=template&id=5e92160c&scoped=true"
import script from "./MessageEditor.vue?vue&type=script&lang=js"
export * from "./MessageEditor.vue?vue&type=script&lang=js"

import "./MessageEditor.vue?vue&type=style&index=0&id=5e92160c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e92160c"]])

export default __exports__